var render, staticRenderFns
import script from "./marquee-text.vue?vue&type=script&lang=js"
export * from "./marquee-text.vue?vue&type=script&lang=js"
import style0 from "./marquee-text.vue?vue&type=style&index=0&id=2279d01d&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports